import {PopupClosable} from './PopupClosable';

export class PopupOptions {
    constructor(public size: 'small' | 'normal' | 'large' | 'custom' = 'normal',
                public isClosable: PopupClosable = 'closable',
                public customWidthPx?: number,
                public customHeightPx?: number) {
    }
}
